import { createFillsGraphRequestForPlCapsule } from 'widgets/plCapsule/store/PlCapsuleStreamRequest';
import { selectStreamKey } from 'widgets/plCapsule/store/data/selectors';
import { clearPlCapsuleDataAction } from 'widgets/plCapsule/store/data/actions';
import { WidgetStreamStreamingConfig } from 'widgets/streaming/WidgetStreamConfig';
import FillsGraphByOrderIdOrSymQtyStreamRequest from 'communication/types/fillsGraph/FillsGraphByOrderIdOrSymQtyStreamRequest';
import FillsGraphDataMessage from 'communication/types/fillsGraph/FillsGraphDataMessage';
import { getFillsGraphMarketDataRequests } from 'widgets/fillsGraph/store/data/marketData';

export const plCapsuleStreamConfig: WidgetStreamStreamingConfig<
    FillsGraphByOrderIdOrSymQtyStreamRequest,
    FillsGraphDataMessage
> = {
    streamType: 'StreamingStream',
    configType: 'OrderIdsDependentWidgetStreamConfig',
    fallsBackToPortfolioSelection: false,
    startChannelDestination: 'startFillsGraphByOrderIdOrSymQtyStream',
    createPayload: createFillsGraphRequestForPlCapsule,
    createMarketDataRequests: getFillsGraphMarketDataRequests,
    selectWidgetStreamKey: selectStreamKey,
    clearWidgetStreamData: clearPlCapsuleDataAction,
    subscriptions: { appSettings: false, widgetConfig: true },
};
